// Tournament table calculation
export function buildTable(teams, games) {
  const stats = teams.map((t, idx) => ({
    idx,
    name: t.name,
    played: 0,
    wins: 0,
    draws: 0,
    losses: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    diff: 0,
    points: 0,
  }));
  for (const g of games) {
    if (g.status !== "beendet" || g.home_goals == null || g.away_goals == null) continue;
    const h = stats[g.home_idx];
    const a = stats[g.away_idx];
    h.played++; a.played++;
    h.goalsFor += g.home_goals;
    h.goalsAgainst += g.away_goals;
    a.goalsFor += g.away_goals;
    a.goalsAgainst += g.home_goals;
    if (g.home_goals > g.away_goals) {
      h.wins++; a.losses++; h.points += 3;
    } else if (g.home_goals < g.away_goals) {
      a.wins++; h.losses++; a.points += 3;
    } else {
      h.draws++; a.draws++; h.points++; a.points++;
    }
  }
  for (const s of stats) s.diff = s.goalsFor - s.goalsAgainst;
  stats.sort(
    (x, y) =>
      y.points - x.points ||
      y.diff - x.diff ||
      y.goalsFor - x.goalsFor ||
      x.name.localeCompare(y.name)
  );
  return stats.map((s, rank) => ({ ...s, rank: rank + 1 }));
}

// Changing-Teams-Modus: Tabelle pro SPIELER. Jeder eingesetzte Spieler bekommt
// Punkte + Tore seines Teams je Spiel. round_rosters[round][slotIdx] = [player,...].
export function buildPlayerTable(tournament) {
  const rosters = tournament.round_rosters || {};
  const byPlayer = new Map();
  const ensure = (p) => {
    const key = p.id || p.name;
    if (!byPlayer.has(key)) {
      byPlayer.set(key, {
        id: key, name: p.name, played: 0, wins: 0, draws: 0, losses: 0,
        goalsFor: 0, goalsAgainst: 0, diff: 0, points: 0,
      });
    }
    return byPlayer.get(key);
  };
  for (const g of tournament.games || []) {
    if (g.status !== "beendet" || g.home_goals == null || g.away_goals == null) continue;
    const roundRosters = rosters[g.round] || rosters[String(g.round)];
    if (!roundRosters) continue;
    const homeRoster = roundRosters[g.home_idx] || [];
    const awayRoster = roundRosters[g.away_idx] || [];
    const apply = (players, gf, ga) => {
      for (const p of players) {
        const s = ensure(p);
        s.played++; s.goalsFor += gf; s.goalsAgainst += ga;
        if (gf > ga) { s.wins++; s.points += 3; }
        else if (gf < ga) { s.losses++; }
        else { s.draws++; s.points++; }
      }
    };
    apply(homeRoster, g.home_goals, g.away_goals);
    apply(awayRoster, g.away_goals, g.home_goals);
  }
  const stats = [...byPlayer.values()];
  for (const s of stats) s.diff = s.goalsFor - s.goalsAgainst;
  stats.sort(
    (x, y) =>
      y.points - x.points ||
      y.diff - x.diff ||
      y.goalsFor - x.goalsFor ||
      x.name.localeCompare(y.name)
  );
  return stats.map((s, rank) => ({ ...s, rank: rank + 1 }));
}


export function progressPct(games) {
  if (games.length === 0) return 0;
  const finished = games.filter((g) => g.status === "beendet").length;
  return Math.round((finished / games.length) * 100);
}

export function tournamentWinner(teams, games) {
  if (games.length === 0 || games.some((g) => g.status !== "beendet")) return null;
  const table = buildTable(teams, games);
  return table[0]?.name || null;
}

export function teamAvgOverall(team) {
  const ps = team.players || [];
  if (ps.length === 0) return 0;
  const vals = ps.map((p) => Number(p.overall || 0));
  return Math.round((vals.reduce((a, b) => a + b, 0) / vals.length) * 10) / 10;
}
